var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Progressbar',{attrs:{"topicId":_vm.topicId}})
}
var staticRenderFns = []

export { render, staticRenderFns }